module.exports = __webpack_public_path__ + "1286abb632c5a409a0a997d11c994e34.ttf";